import {ModelWithParent} from "FormBuilder/Core/Models/ModelWithParenth";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldWithPriceBaseModel} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Model";
import {OptionsCalculator} from "FormBuilder/Core/Calulators/OptionsCalculator";
import {FBCheckBoxOptions} from "./FBCheckBox.Options";
import {OptionItem} from "FormBuilder/Fields/Options/OptionItem";
import {FBMultipleOptionsBaseModel} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Model";

export class FBCheckBoxModel extends FBMultipleOptionsBaseModel<FBCheckBoxOptions,FBColumnModel>{


    constructor(Options: FBCheckBoxOptions, Parent: FBColumnModel) {
        super(Options, Parent);


    }



    GetDynamicFieldNames(): string[] {
        return ['FBCheckBox'];
    }
}